import React from "react";
import FullCalendar from "@fullcalendar/react";
import * as moment from "moment";
import dayGridPlugin from "@fullcalendar/daygrid";
import { percentToRGB, getFontColorFromHex } from "../../../../libs/colors";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";

const AttendanceQuery = gql`
  query {
    getCountAttendance {
      attendance_date
      count
      percentage
      label
    }
  }
`;

const doughnutDeal = {
  labels: [
    "Collect Document",
    "Review Document",
    "Submit Result",
    "Final Discussion",
    "Closed",
  ],
  options: {
    title: {
      display: true,
      text: "Best!",
      position: "left",
    },
    legend: {
      position: "right",
    },
  },
  datasets: [
    {
      data: [300, 50, 100, 20, 92],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#673ab7", "#20c997"],
      hoverBackgroundColor: [
        "#FF6384",
        "#36A2EB",
        "#FFCE56",
        "#673ab7",
        "#20c997",
      ],
    },
  ],
};

const Calendar = (props) => {
  const { data, loading, error, refetch } = useQuery(AttendanceQuery);

  const calendarData = data
    ? data.getCountAttendance.map((x, index) => {
        // console.log(reduce);
        let day = moment(x.attendance_date).format("YYYY-MM-DD");

        let title = x.label + ` Employee (${(x.percentage / 100).toFixed(1)}%)`;
        let color = percentToRGB(x.percentage);
        let colorHex = color.reduce((prev, current) => {
          return `${prev}${("0" + current.toString(16)).slice(-2)}`;
        }, "#");
        return {
          date: day,
          title: title,
          classNames: ["calendarevent"],
          backgroundColor: colorHex,
          textColor: getFontColorFromHex(colorHex),
        };
      })
    : [];

  // console.log(calendarData);

  return (
    <>
      <FullCalendar
        aspectRatio={3.4}
        defaultView="dayGridMonth"
        plugins={[dayGridPlugin]}
        events={calendarData}
      />
    </>
  );
};

export default Calendar;
